module.exports = __webpack_public_path__ + "img/birds.d9bb1b3.svg";